import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ServicePage from './Service/ServicePage.tsx'
import HomePage from './HomePage/HomePage'
import AboutUsPage from './About us/AboutUsPage'
import Blog from './Blog/Blog.tsx'
import WebDevelopmentPage from './web development/WebDevelopmentPage'
import FullStackPage from './full stack/FullStackPage'
import MobilePage from './Mobile App/MobilePage'
import WebDesignPage from './Web Design/WebDesignPage.tsx'
import DigitalMarketingPage from './Digital Marketing/DigitalMarketingPage.tsx'
import PortfolioPage from './Portfolio/PortfolioPage'
import ECommercePage from './E-commerce/ECommercePage'
import ProductPage from './Products/ProductPage.tsx'
import ContactPage from './Contact/ContactPage'
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import StaffAugmentation from './StaffAugmentation/StaffAugmentation.tsx';
import Blogpage1 from './Blog page/Blogpage1.tsx';
import Blogpage2 from './Blog page/Blogpage2.tsx';
import Blogpage3 from './Blog page/Blogpage3.tsx';
import Blogpage4 from './Blog page/Blogpage4.tsx';
import Blogpage5 from './Blog page/Blogpage5.tsx';
import Blogpage6 from './Blog page/Blogpage6.tsx';

function ScrollToTopOnMount() {
  const history = useHistory();

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  return null;
}

const App = () => {
  return (
    <>
      <Router>
        <ScrollToTopOnMount />
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Route path="/Service" component={ServicePage} />
          <Route path="/Products" component={ProductPage} />
          <Route path="/Portfolio" component={PortfolioPage} />
          <Route path="/aboutUs" component={AboutUsPage} />
          <Route path="/Blog-page" component={Blog}/>
          <Route path="/contact" component={ContactPage} /> 
          <Route path="/website-development-services" component={WebDevelopmentPage} />
          <Route path="/fullstack-service" component={FullStackPage} />
          <Route path="/Mobile-App-service" component={MobilePage} />
          <Route path="/E-Commerce-Service" component={ECommercePage} />
          <Route path="/WebDesign-service" component={WebDesignPage} />
          <Route path="/digital-Marketing" component={DigitalMarketingPage} />
          <Route path="/staff-augmentation" component={StaffAugmentation} />
          <Route path="/Blog-page1" component={Blogpage1}/>
          <Route path="/Blog-page2" component={Blogpage2}/>
          <Route path="/Blog-page3" component={Blogpage3}/>
          <Route path="/Blog-page4" component={Blogpage4}/>
          <Route path="/Blog-page5" component={Blogpage5}/>
          <Route path="/Blog-page6" component={Blogpage6}/>
        </Switch>
      </Router> 
    </>
  )
}

export default App
